var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{staticClass:"px-2",attrs:{"type":"dark","variant":"warning"}},[_c('b-navbar-brand',{attrs:{"href":"/"}},[_c('strong',[_vm._v(_vm._s(_vm.env.APP_NAME))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }